import { render, staticRenderFns } from "./HeaderSocialMenu.vue?vue&type=template&id=6bea62f8&"
import script from "./HeaderSocialMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderSocialMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports